export const ht = {
  // Common
  "common": {
    "welcome": "Byenveni nan",
    "search": "Chèche",
    "loading": "Ap chaje...",
    "error": "Yon erè te fèt",
    "save": "Anrejistre",
    "cancel": "Anile",
    "delete": "Efase",
    "edit": "Modifye",
    "view": "Gade",
    "viewAll": "Gade tout",
    "add": "Ajoute",
    "remove": "Retire",
    "back": "Retounen",
    "next": "Pwochen",
    "previous": "Anvan",
    "submit": "Soumèt",
    "confirm": "Konfime",
    "success": "Siksè",
    "warning": "Avètisman",
    "info": "Enfòmasyon",
    "required": "Obligatwa",
    "optional": "Opsyonèl",
    "all": "Tout",
    "active": "Aktif",
    "inactive": "Inaktif",
    "pending": "An atant",
    "completed": "Konplete",
    "cancelled": "Anile",
    "rejected": "Rejte",
    "approved": "Apwouve",
    "yes": "Wi",
    "no": "Non",
    "or": "oswa",
    "and": "ak",
    "saving": "Ap anrejistre...",
    "updating": "Ap mete ajou...",
    "deleting": "Ap efase...",
    "processing": "Ap trete...",
    "pleaseWait": "Tanpri tann...",
    "notFound": "Pa jwenn",
    "noResults": "Pa gen rezilta",
    "noData": "Pa gen done disponib",
    "close": "Fèmen",
    "apply": "Aplike",
    "reset": "Reyinisyalize",
    "clearAll": "Efase tout",
    "clearFilters": "Efase filtè yo",
    "retry": "Eseye ankò"
  },
  
  // Navigation
  "nav": {
    "home": "Akèy",
    "products": "Pwodwi",
    "videos": "Videyo",
    "cart": "Panye",
    "wishlist": "Lis Swè",
    "profile": "Pwofil",
    "settings": "Paramèt",
    "becomeSeller": "Vin yon Vandè",
    "becomeDelivery": "Vin yon Livrè",
    "sellerDashboard": "Tablo Vandè",
    "deliveryDashboard": "Tablo Livrè",
    "management": "Jesyon",
    "competitions": "Konpetisyon",
    "login": "Konekte",
    "register": "Enskri",
    "logout": "Dekonekte",
    "admin": "Administrasyon",
    "orders": "Kòmand",
    "sellers": "Vandè",
    "deliveryPartners": "Livrè",
    "deliveries": "Livrezon",
    "users": "Itilizatè",
    "payments": "Peman",
    "paymentHistory": "Istorik Peman"
  },
  
  // Home page
  "home": {
    "hero": {
      "title": "Byenveni nan AEM Marketplace",
      "subtitle": "Destinasyon ou pou achte, vann, epi livre pwodwi fasilman. Antre nan kominote vandè ak achtè nou yo jodi a!",
      "browseProducts": "Gade Pwodwi yo",
      "becomeSeller": "Vin yon Vandè"
    },
    "categories": {
      "title": "Kategori Popilè",
      "subtitle": "Eksplore divès kalite pwodwi nou yo"
    },
    "featuredProducts": {
      "title": "Pwodwi Vedèt"
    },
    "testimonials": {
      "title": "Sa Itilizatè Nou Yo Di",
      "subtitle": "Dekouvri eksperyans nan kominote k ap grandi nou an",
      "buyer": "Achtè",
      "seller": "Vandè",
      "delivery": "Patnè Livrezon"
    },
    "stats": {
      "title": "AEM Marketplace an Chif",
      "subtitle": "Antre nan kominote k ap grandi nou an jodi a",
      "users": "Itilizatè",
      "products": "Pwodwi",
      "deliveries": "Livrezon",
      "satisfaction": "Satisfaksyon"
    },
    "howItWorks": {
      "title": "Kijan Li Mache",
      "subtitle": "Achte ak vann fasilman sou platfòm nou an",
      "cta": "Kòmanse Kounye a",
      "step1": {
        "title": "Gade Pwodwi Yo",
        "description": "Eksplore katalòg vast nou an ki gen pwodwi kalite"
      },
      "step2": {
        "title": "Fè Kòmand",
        "description": "Chwazi atik ou yo epi fè peman an sekirite"
      },
      "step3": {
        "title": "Livrezon Rapid",
        "description": "Patnè livrezon nou yo okipe tout bagay"
      },
      "step4": {
        "title": "Jwi Acha Ou",
        "description": "Resevwa pwodwi ou yo epi pataje eksperyans ou"
      }
    }
  },
  
  // Products
  "products": {
    "title": "Tout Pwodwi",
    "subtitle": "Gade koleksyon pwodwi inik nou yo",
    "filters": "Filtre",
    "activeFilters": "Filtre aktif",
    "noProductsFound": "Pa gen pwodwi ki koresponn ak kritè rechèch ou yo",
    "sort": {
      "title": "Triye pa",
      "newest": "Pi resan",
      "priceAsc": "Pri: Pi ba a pi wo",
      "priceDesc": "Pri: Pi wo a pi ba",
      "popular": "Pi popilè"
    },
    "addToCart": "Ajoute nan panye",
    "addedToCart": "Ajoute nan panye",
    "outOfStock": "Pa disponib",
    "price": "Pri",
    "minPrice": "Pri minimòm",
    "category": "Kategori",
    "seller": "Vandè",
    "description": "Deskripsyon",
    "deliveryOptions": "Opsyon Livrezon",
    "standard": "Estanda",
    "express": "Ekspres",
    "pickup": "Ranmase",
    "pickupAddress": "Adrès pou ranmase",
    "estimatedDelivery": "Tan livrezon estime",
    "days": "jou",
    "reviews": "Kòmantè",
    "writeReview": "Ekri yon kòmantè",
    "noReviews": "Pa gen kòmantè pou kounye a",
    "rating": "Nòt",
    "comment": "Kòmantè",
    "submitReview": "Pibliye kòmantè",
    "productDetails": "Detay pwodwi"
  },
  
  // Cart
  "cart": {
    "title": "Panye Ou",
    "empty": "Panye ou vid",
    "addProducts": "Ajoute pwodwi pou kòmanse achte",
    "browseProducts": "Gade pwodwi yo",
    "summary": "Rezime kòmand",
    "subtotal": "Soutotal",
    "shipping": "Frè livrezon",
    "tax": "Taks",
    "total": "Total",
    "checkout": "Peye",
    "continueShopping": "Kontinye achte",
    "remove": "Retire",
    "quantity": "Kantite",
    "delivery": "Livrezon",
    "payment": "Peman",
    "deliveryInfo": "Enfòmasyon livrezon",
    "address": "Adrès",
    "city": "Vil",
    "zipCode": "Kòd postal",
    "phone": "Telefòn",
    "continueToDelivery": "Kontinye nan livrezon",
    "continueToPayment": "Kontinye nan peman",
    "finalizePayment": "Finalize peman",
    "paymentSuccess": "Peman reyisi!",
    "orderConfirmed": "Kòmand ou konfime epi l ap trete rapidman. W ap resevwa yon imèl konfimasyon avèk detay kòmand ou.",
    "redirecting": "Ap redirije nan paj pwodwi yo..."
  },
  
  // Auth
  "auth": {
    "login": {
      "title": "Byenveni nan AEM",
      "subtitle": "Konekte nan kont ou",
      "noAccount": "Ou pa gen yon kont?",
      "createAccount": "Kreye yon kont",
      "email": "Adrès imèl",
      "password": "Modpas",
      "forgotPassword": "Bliye modpas?",
      "loginButton": "Konekte",
      "loggingIn": "Ap konekte..."
    },
    "register": {
      "title": "Kreye kont ou",
      "subtitle": "Ou gen yon kont deja?",
      "signIn": "Konekte",
      "email": "Adrès imèl",
      "password": "Modpas",
      "role": "Mwen vle",
      "buy": "Achte",
      "sell": "Vann",
      "deliver": "Livre",
      "createButton": "Kreye kont",
      "creating": "Ap kreye kont..."
    }
  },
  
  // Settings
  "settings": {
    "title": "Paramèt",
    "subtitle": "Jere preferans ou ak enfòmasyon kont ou",
    "tabs": {
      "profile": "Pwofil",
      "security": "Sekirite",
      "notifications": "Notifikasyon",
      "language": "Lang ak Rejyon"
    },
    "profile": {
      "fullName": "Non Konplè",
      "email": "Imèl",
      "emailCannotBeChanged": "Imèl la pa kapab chanje",
      "phoneNumber": "Nimewo Telefòn",
      "region": "Rejyon",
      "regionPlaceholder": "Rejyon ou (egzanp: Pòtoprens)",
      "saveChanges": "Anrejistre Chanjman yo",
      "saving": "Ap anrejistre..."
    },
    "security": {
      "currentPassword": "Modpas Aktyèl",
      "newPassword": "Nouvo Modpas",
      "confirmPassword": "Konfime Modpas",
      "passwordRequirements": "Modpas la dwe gen omwen 6 karaktè",
      "securityTips": "Konsèy Sekirite",
      "tip1": "Itilize yon modpas inik pou chak sit",
      "tip2": "Mete lèt majiskil, lèt miniskil, chif, ak senbòl",
      "tip3": "Evite itilize enfòmasyon pèsonèl ki fasil pou devine",
      "updatePassword": "Mete ajou Modpas",
      "updating": "Ap mete ajou..."
    },
    "notifications": {
      "emailNotifications": "Notifikasyon pa imèl",
      "allNotifications": "Tout notifikasyon",
      "orderUpdates": "Mizajou kòmand",
      "statusAndDelivery": "Estati ak livrezon",
      "marketingEmails": "Imèl maketing",
      "promotionsAndOffers": "Pwomosyon ak òf",
      "newMessages": "Nouvo mesaj",
      "chatsAndNegotiations": "Chat ak negosyasyon",
      "aboutNotifications": "Sou Notifikasyon",
      "notificationsHelp": "Notifikasyon yo ede w rete enfòme sou aktivite enpòtan nan kont ou. Ou ka pèsonalize yo selon preferans ou.",
      "savePreferences": "Anrejistre Preferans"
    },
    "language": {
      "language": "Lang",
      "region": "Rejyon",
      "regionPlaceholder": "Rejyon ou (egzanp: Pòtoprens)",
      "regionalPreferences": "Preferans rejyonal",
      "regionalPreferencesHelp": "Paramèt sa yo afekte fason dat, pri, ak lòt eleman rejyonal yo afiche.",
      "savePreferences": "Anrejistre Preferans"
    },
    "deleteAccount": {
      "title": "Efase Kont",
      "warning": "Lè w efase kont ou, tout done w yo ap efase definitivman. Aksyon sa a pa ka anile.",
      "deleteButton": "Efase Kont",
      "disabledMessage": "Efase kont dezaktive nan demo sa a"
    }
  },
  
  // Seller
  "seller": {
    "dashboard": {
      "title": "Tablo Vandè",
      "products": "Pwodwi",
      "orders": "Kòmand",
      "delivery": "Livrezon",
      "videos": "Videyo",
      "revenue": "Revni",
      "payments": "Peman",
      "settings": "Paramèt",
      "addProduct": "Ajoute Pwodwi",
      "searchProduct": "Chèche yon pwodwi...",
      "noProducts": "Pa gen pwodwi pou kounye a",
      "productLimitReached": "Limit pwodwi atenn",
      "views": "vizit",
      "sales": "vant",
      "active": "aktif"
    }
  },
  
  // Videos
  "videos": {
    "title": "Videyo Pwodwi",
    "subtitle": "Gade demonstrasyon ak kòmantè pwodwi nan kominote nou an",
    "myVideos": "Videyo Mwen",
    "allVideos": "Tout Videyo",
    "uploadVideo": "Telechaje Videyo",
    "noVideos": "Pa gen videyo pou kounye a",
    "uploadYourFirst": "Telechaje premye videyo ou",
    "recent": "Resan",
    "popular": "Popilè",
    "views": "vizit",
    "likes": "renmen",
    "comments": "kòmantè",
    "addComment": "Ajoute yon kòmantè...",
    "loginToComment": "Konekte pou ajoute yon kòmantè",
    "noComments": "Pa gen kòmantè pou kounye a",
    "relatedProduct": "Pwodwi asosye",
    "viewProduct": "Gade pwodwi",
    "statistics": "Estatistik",
    "publishedOn": "Pibliye le",
    "deleteVideo": "Efase videyo",
    "deleteConfirmation": "Èske ou sèten ou vle efase videyo sa a? Aksyon sa a pa ka anile.",
    "videoDeleted": "Videyo efase avèk siksè"
  }
};